import * as React from 'react'
import { Link } from 'react-router'
import CHANNELS, { channelById } from '../../../constants/Channels'

interface Props {
  channelId: number
  viewListingId?: number
  marketAccountId?: number
}

export const ListingManagerLink: React.FC<Props> = props => {
  const channel = channelById(props.channelId)

  if (channel === CHANNELS.SHOPIFY) {
    return (
      props.marketAccountId && (
        <Link to={`/listings/shopify_account/${props.marketAccountId}?viewListingId=${props.viewListingId}`}>
          {props.children}
        </Link>
      )
    )
  }
  if (channel === CHANNELS.EBAY) {
    return (
      props.marketAccountId && (
        <Link to={`/listings/ebay_account/${props.marketAccountId}?viewListingId=${props.viewListingId}`}>
          {props.children}
        </Link>
      )
    )
  }

  if (channel === CHANNELS.DEPOP) {
    return (
      props.marketAccountId && (
        <Link to={`/listings/depop_account/${props.marketAccountId}?viewListingId=${props.viewListingId}`}>
          {props.children}
        </Link>
      )
    )
  }

  return <Link to={`/listings/${channel.name}?viewListingId=${props.viewListingId}`}>{props.children}</Link>
}
